import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { MediaQuery as MQ } from '../../shared/media-query';
import { toggleDOMClass } from '../../shared/util';

class Component extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            openAccordions: {},
            showNav: false,
        };

        this.showNavElements = 'body, main, footer, top-bar, article-collection, mobile-action-bar';
    }

    shouldComponentUpdate(nextProps, nextState) {
        if ((MQ.isMobile() || MQ.isTabletPortrait()) && nextState.openAccordions != this.state.openAccordions) {
            return true;
        }

        if (nextState.showNav != this.state.showNav) {
            return true;
        }

        return false;
    }

    render({ nav }, { showNav }) {
        return [
            <article-nav>
                <ul className='level-1'>
                    {nav.map(folder => this.renderFolder(folder, 1, `Nav:${folder.title}`))}
                </ul>
            </article-nav>,
            <overlay className={showNav && 'show-nav'} onClick={this.closeMenu} />,
        ];
    }

    renderFolder = (folder, level, label) => {
        const { showNav, openAccordions } = this.state;
        const hasChildren = folder.children && folder.children.length > 0;
        let className = location.pathname == folder.custom_url ? 'active' : '';
        className += hasChildren ? ' has-children' : '';

        const isOpen = showNav && openAccordions[level] && openAccordions[level] == folder.title;

        if ((MQ.isMobile() || MQ.isTabletPortrait()) && hasChildren) {
            return (
                <li className={`level-${level} ${isOpen ? 'open' : 'closed'}`}>
                    <a
                        className={className}
                        onClick={(e) => {
                            this.trackClick(e, label, level, folder);
                        }}
                    >
                        {this.renderTitle(folder.title, level)}
                    </a>
                    {this.renderChildren(folder, level + 1, label)}
                </li>
            );
        }

        return (
            <li className={`level-${level}`}>
                <a
                    href={folder.custom_url}
                    className={className}
                    onClick={(e) => this.trackClick(e, label, level, folder)}
                >
                    {this.renderTitle(folder.title, level)}
                </a>
                {hasChildren && this.renderChildren(folder, level + 1, label)}
            </li>
        );
    }

    renderTitle = (title, level) => {
        const Title = level <= 4 ? `h${level + 1}` : 'p';
        return (<Title>{title}</Title>);
    }

    renderChildren = (folder, level, label) => {
        if (folder.children && folder.children.length > 0) {
            return (
                <ul
                    className={`level-${level}`}
                    open={this.props.current && this.props.current.custom_url.match(folder.custom_url) != null}
                >
                    {this.renderViewAll(folder, level, label)}
                    {folder.children.map(child => this.renderFolder(child, level, `${label}:${child.title}`))}
                </ul>
            );
        }

        return null;
    }

    renderViewAll = (folder, level, label) => {
        if (level == 2 || MQ.isMobile() || MQ.isTabletPortrait()) {
            return (
                <li className='is-hidden-desktop'>
                    <a
                        href={folder.custom_url}
                        className={location.pathname == folder.custom_url ? 'active' : ''}
                        onClick={(e) => this.trackClick(e, label, level)}
                    >
                        {this.renderTitle('View All', level)}
                    </a>
                </li>
            );
        }

        return null;
    }

    trackClick = (e, label, level, folder) => {
        const hasChildren = folder.children && folder.children.length > 0;

        if (hasChildren && (MQ.isMobile() || MQ.isTabletPortrait())) {
            e.preventDefault();
            e.stopPropagation();

            if (folder.title == this.state.openAccordions[level]) {
                this.closeMenu(null, level);
            } else {
                this.openMenu(level, folder.title);
            }
        }

        this.props.trackEvent([
            'Article Collection: Nav',
            'Click',
            label,
            `Nav_AC:${label}`,
        ]);
    }

    openMenu = (level, title) => {
        toggleDOMClass(this.showNavElements, 'show-nav', 'add');

        this.setState({
            openAccordions: {
                ...this.state.openAccordions,
                [level]: title,
            },
            showNav: true,
        });
    }

    closeMenu = (e, level = null) => {
        if (level && level > 1) {
            this.setState({
                openAccordions: {
                    ...this.state.openAccordions,
                    [level]: null,
                },
            });
        } else {
            toggleDOMClass(this.showNavElements, 'show-nav', 'remove');
            this.setState({ showNav: false, openAccordions: {}});
        }
    }
}

const mapStateToProps = (state) => ({
    current: state.articles && state.articles.current,
    nav: state.articles && state.articles.nav,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({
        type: 'ga:event',
        payload: payload,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);